import {
  ChangeDetectorRef,
  Component,
  NgZone,
  OnDestroy,
  ViewChild,
  HostListener,
  Directive,
  AfterViewInit,
  ViewEncapsulation
} from '@angular/core';
import { MediaMatcher } from '@angular/cdk/layout';
import { RouterModule, Router } from '@angular/router';
import { SidebarFacadeService } from './sidebar-facade.service';
import { LoginService } from 'app/services/login.service';
import * as CryptoJS from 'crypto-js';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./slidebar.style.scss']
})
export class AppSidebarComponent implements OnDestroy {
  mobileQuery: MediaQueryList;

  private _mobileQueryListener: () => void;
  public menus: any[];

  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private _route: Router,
    public sidebarService: SidebarFacadeService,
    public loginService:LoginService
  ) {
    this.mobileQuery = media.matchMedia('(min-width: 768px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.consumirMenus();
  }
  consumirMenus() {
    const encryptedData = localStorage.getItem("MFX_01");  // Recuperar los datos encriptados desde localStorage
    if (encryptedData) {
        const decryptedData = CryptoJS.AES.decrypt(encryptedData, localStorage.getItem("token-posgrado")).toString(CryptoJS.enc.Utf8);  // Desencriptar
        
        try {
            var menus1 = JSON.parse(decryptedData);  // Parsear la cadena JSON desencriptada
        } catch (error) {
        }
    }

    // Asignar los menús desencriptados a la variable en memoria
    this.menus = menus1 || [];
    
    // Usar los menús desencriptados en la lógica de tu aplicación
    this.sidebarService.setearMenus(this.menus);
}
  // consumirMenus() {
  //   this.menus = JSON.parse(localStorage.getItem("menus"));
  //   if(this.menus == null){
  //       this.menus = [];
  //   }
  //   this.sidebarService.setearMenus(this.menus);

  // }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  salir() {
    this.loginService.cerrarSesion();
    this._route.navigateByUrl('/login');
  }

}
